"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Search = _interopRequireDefault(require("@material-ui/icons/Search"));

var _InputAdornment = _interopRequireDefault(require("@eig-builder/core-ui/InputAdornment"));

var _TextField = _interopRequireDefault(require("@eig-builder/core-ui/TextField"));

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

var _context = _interopRequireDefault(require("@eig-builder/module-localization/context"));

var _dataGridContext = require("../../data-grid-context");

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  width: 24px !important;\n  cursor: pointer;\n  transition: width 0.6s ease-in-out;\n  padding-top: ", " !important;\n  padding-bottom: ", " !important;\n\n  > div,\n  input:hover {\n    cursor: pointer !important;\n  }\n\n  &.open {\n    width: 180px !important;\n  }\n\n  & .MuiInput-underline:before {\n    content: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SearchBar = (0, _styledComponents["default"])(_TextField["default"])(_templateObject(), function (props) {
  return props.theme.spacing(2);
}, function (props) {
  return props.theme.spacing(2);
});

var SearchContextContainer = function SearchContextContainer(props) {
  var _useDataGridContext = (0, _dataGridContext.useDataGridContext)(),
      searchQuery = _useDataGridContext.searchQuery,
      setSearchQuery = _useDataGridContext.setSearchQuery;

  return /*#__PURE__*/_react["default"].createElement(Search, (0, _extends2["default"])({
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery
  }, props));
};

var Search = function Search(_ref) {
  var showPlaceholderText = _ref.showPlaceholderText,
      searchPlaceholder = _ref.searchPlaceholder,
      searchQuery = _ref.searchQuery,
      setSearchQuery = _ref.setSearchQuery,
      disabled = _ref.disabled,
      tag = _ref.tag;

  var _useContext = (0, _react.useContext)(_context["default"]),
      localize = _useContext.localize;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      openSearchbar = _useState2[0],
      setOpenSearchbar = _useState2[1];

  var _useState3 = (0, _react.useState)(localize('core.components.datatable.searchFilter.placeholder')),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      searchPlaceholderText = _useState4[0],
      setSearchPlaceholderText = _useState4[1];

  var inputRef = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (searchPlaceholder) {
      setSearchPlaceholderText(searchPlaceholder);
    }
  }, [searchPlaceholderText, searchPlaceholder]);

  var handleClickSearch = function handleClickSearch() {
    setOpenSearchbar(true);
    inputRef.current.focus();
  };

  var handleLeaveSearchbar = function handleLeaveSearchbar() {
    if ((0, _isEmpty["default"])(searchQuery)) {
      setOpenSearchbar(false);
    }
  };

  var onChangeSearch = function onChangeSearch(event) {
    setSearchQuery(event.target.value);
  };

  return /*#__PURE__*/_react["default"].createElement(SearchBar, {
    placeholder: showPlaceholderText && searchPlaceholderText,
    className: openSearchbar && 'open',
    value: searchQuery,
    disabled: disabled,
    InputProps: {
      inputRef: inputRef,
      startAdornment: /*#__PURE__*/_react["default"].createElement(_InputAdornment["default"], {
        position: "start"
      }, /*#__PURE__*/_react["default"].createElement(_Search["default"], {
        onClick: handleClickSearch
      }))
    },
    onBlur: handleLeaveSearchbar,
    onChange: onChangeSearch,
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "field",
    dataElementId: 'search-' + tag
  });
};

Search.propTypes = {
  tag: _propTypes["default"].string,
  showPlaceholderText: _propTypes["default"].bool,
  searchPlaceholder: _propTypes["default"].string,
  searchQuery: _propTypes["default"].string,
  setSearchQuery: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool
};
Search.defaultProps = {
  showPlaceholderText: false
};
var _default = SearchContextContainer;
exports["default"] = _default;